import { applyMiddleware, createStore, combineReducers, Store, PreloadedState } from 'redux';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import createCompressor from 'redux-persist-transform-compress';

import { GlobalState } from './reducers';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { Persistor } from 'redux-persist/es/types';
import idbBackUpReduxMiddleware from './idbBackupReduxMiddleware';
import { Actions } from './actions';
import appReduxMiddleware from './appReduxMiddleware';
import sessionReducer, { initialSessionState } from './reducers/session';

const APP_NAME = 'prescription-app';

export const initialState: GlobalState = {
    session: initialSessionState,
};

const migrations = {};

const WHITELIST_REDUCERS: string[] = [];
const compressor = createCompressor({ whitelist: WHITELIST_REDUCERS });
const persistConfig = {
    key: APP_NAME,
    version: 2,
    migrate: createMigrate<GlobalState>(migrations, { debug: true }),
    whitelist: WHITELIST_REDUCERS,
    transforms: [compressor],
};

const reducers = combineReducers({
    session: sessionReducer,
});

const logger = createLogger({
    duration: true,
    diff: true,
});

const middlewares = [thunk, appReduxMiddleware, idbBackUpReduxMiddleware];

if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger as any);
}

const configureStore = (
    preloaded?: PreloadedState<GlobalState & PersistPartial>,
): { store: Store; persistor: Persistor } => {
    // TODO add types
    const store: Store = createStore<GlobalState & PersistPartial, Actions, any, any>(
        persistReducer<GlobalState, Actions>({ ...persistConfig, storage }, reducers),
        preloaded,
        composeWithDevTools(applyMiddleware(...middlewares)),
    );

    const persistor = persistStore(store);
    return { store, persistor };
};

export default configureStore;
